export const types = {
  SET_PIPELINES: 'SET_PIPELINES',
  REMOVE_PIPELINE: 'REMOVE_PIPELINE',
  SET_CARDS: 'SET_CARDS',
  ADD_CARD: 'ADD_CARD',
  UPDATE_CARD: 'UPDATE_CARD',
  REMOVE_CARD: 'REMOVE_CARD',
  SET_ACTIVE_PIPELINE: 'SET_ACTIVE_PIPELINE',
  SET_ACTIVE_FILTERS: 'SET_ACTIVE_FILTERS',
  SET_UI_FLAG: 'SET_UI_FLAG',
  BULK_UPDATE_CARDS: 'BULK_UPDATE_CARDS',
  BULK_REMOVE_CARDS: 'BULK_REMOVE_CARDS',
  UPDATE_PIPELINE_COLUMNS: 'UPDATE_PIPELINE_COLUMNS',
};

export default {
  [types.SET_PIPELINES](state, pipelines) {
    state.pipelines = pipelines;
  },
  [types.REMOVE_PIPELINE](state, pipelineId) {
    state.pipelines = state.pipelines.filter(p => p.id !== pipelineId);
  },
  [types.SET_CARDS](state, cards) {
    state.cards = cards;
  },
  [types.ADD_CARD](state, card) {
    state.cards = [...state.cards, card];
  },
  [types.UPDATE_CARD](state, updatedCard) {
    const idx = state.cards.findIndex(c => c.id === updatedCard.id);
    if (idx !== -1) {
      state.cards = state.cards.map(c =>
        c.id === updatedCard.id ? updatedCard : c
      );
    } else {
      state.cards = [...state.cards, updatedCard];
    }
  },
  [types.REMOVE_CARD](state, cardId) {
    state.cards = state.cards.filter(c => c.id !== cardId);
  },
  [types.SET_ACTIVE_PIPELINE](state, pipelineId) {
    state.activePipelineId = pipelineId;
  },
  [types.SET_ACTIVE_FILTERS](state, filters) {
    state.activeFilters = filters;
  },
  [types.SET_UI_FLAG](state, flags) {
    state.uiFlags = { ...state.uiFlags, ...flags };
  },
  [types.BULK_UPDATE_CARDS](state, updatedCards) {
    const map = new Map(updatedCards.map(c => [c.id, c]));
    state.cards = state.cards.map(c => map.get(c.id) ?? c);
  },
  [types.BULK_REMOVE_CARDS](state, ids) {
    const set = new Set(ids);
    state.cards = state.cards.filter(c => !set.has(c.id));
  },
  [types.UPDATE_PIPELINE_COLUMNS](state, { pipelineId, columns }) {
    state.pipelines = state.pipelines.map(p =>
      p.id === pipelineId ? { ...p, columns } : p
    );
  },
};
